
import React from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useIsMobile } from "@/hooks/use-mobile";

interface SkillBadgeProps {
  name: string;
  description: string;
  expertise?: string;
  isEven: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

const SkillBadge: React.FC<SkillBadgeProps> = ({ 
  name, 
  description, 
  expertise, 
  isEven,
  onMouseEnter,
  onMouseLeave 
}) => {
  const isMobile = useIsMobile();
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  
  const handleTouch = () => {
    if (isMobile) {
      setIsTooltipOpen(prev => !prev);
    }
  };
  
  return (
    <HoverCard 
      openDelay={300} 
      closeDelay={200}
      open={isMobile ? isTooltipOpen : undefined}
    >
      <HoverCardTrigger asChild>
        <span 
          className={`inline-block cursor-pointer ${isEven ? 'skill-badge' : 'skill-badge-alt'}`}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={handleTouch}
          onTouchEnd={(e) => {
            e.preventDefault(); // Prevent default touch behavior
            handleTouch();
          }}
          role="button"
          tabIndex={0}
          aria-label={`Skill: ${name}. Tap for details.`}
        >
          {name}
        </span>
      </HoverCardTrigger>
      <HoverCardContent 
        side={isMobile ? "bottom" : "top"} 
        className="bg-white shadow-md p-4 max-w-xs z-50"
        onEscapeKeyDown={() => setIsTooltipOpen(false)}
      >
        <div>
          <h4 className="text-sm font-medium text-sage-800 mb-1">{name}</h4>
          <p className="text-sm text-gray-700 mb-2">{description}</p>
          {expertise && (
            <p className="text-sm font-medium text-sage-700 mt-2 border-t border-sage-100 pt-2">
              {expertise}
            </p>
          )}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default SkillBadge;
